export const baseURL = "https://teenpatti.parilive.in/";
export const adminBaseURL = "https://admin.parilive.in/";
export const key = "5TIvw5cpc0";
